import { ClientSafeProvider, getProviders } from "next-auth/react";
import { useEffect, useState } from "react";

export interface NextAuthProvidersQuery {
  error: string | undefined;
  loading: boolean;
  providers: ProviderMap | undefined;
  retry: () => void;
}

interface ProviderMap {
  [index: string]: ClientSafeProvider;
}

export function useNextAuthProviders(): NextAuthProvidersQuery {
  const [error, setError] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [providers, setProviders] = useState<ProviderMap | undefined>(undefined);
  const [revision, setRevision] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(undefined);
    const fetchData = async () => {
      try {
        const res = await getProviders();
        if (res == null || Object.keys(res).length === 0)
          throw new Error("No authentication providers returned");
        if (!cancelled) setProviders(res);
      } catch (e) {
        if (!cancelled) setError("Could not load sign-in options. Please try again.");
        console.error(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchData();
    return () => {
      cancelled = true;
    };
  }, [revision]);

  return { error, loading, providers, retry: () => setRevision((value) => value + 1) };
}
